import { ReactElement } from "react";

import useScrollUpOnMount from "seneca-common/utils/hooks/scrolling/useScrollUpOnMount";

type Props = {
  children: ReactElement;
};

export default function ScrollToTopOnMount({ children }: Props) {
  useScrollUpOnMount();

  return children;
}
